import type { AthenaClientInternals } from "../../runtime/client-internals.ts";

export type AthenaBillingDiagnosticsPhase =
	| "unconfigured"
	| "provider-registry"
	| "materializing-connections"
	| "attaching-ingress"
	| "registering-schedulers"
	| "ready"
	| "failed";

export type AthenaBillingDiagnostics = {
	connectionCount: number;
	failure?: {
		code?: string;
		message: string;
		stage: string;
	};
	phase: AthenaBillingDiagnosticsPhase;
	readyAt?: number;
	startedAt?: number;
};

export type AthenaBillingInspectedConnection = {
	accountReference: string;
	credentialReference: string;
	id: string;
	provider: "mollie";
};

export function emptyBillingDiagnostics(): AthenaBillingDiagnostics {
	return {
		connectionCount: 0,
		phase: "unconfigured",
	};
}

export function patchBillingDiagnostics(
	internals: AthenaClientInternals | undefined,
	patch: Partial<AthenaBillingDiagnostics>,
): void {
	if (!internals) {
		return;
	}
	const current = internals.billingDiagnostics ?? emptyBillingDiagnostics();
	internals.billingDiagnostics = {
		...current,
		...patch,
		failure: patch.failure ?? current.failure,
	};
}
